var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"labelcontainer"},[_c('label',{class:{
      'bold _xl': _vm.size === 'xl',
      'bold _large': _vm.size === 'large',
      'bold _medium': _vm.size === 'medium',
      'bold _small': _vm.size === 'small',
    }},[_vm._v(" "+_vm._s(_vm.label)+": ")]),(_vm.value == 'null' || _vm.value == '..onbekend..' || _vm.value == '€ null' || _vm.value == null || _vm.value == undefined || _vm.value == 'undefined')?_c('input',{staticClass:"form-control label",attrs:{"type":"text","name":"soort","value":"","readonly":""}}):_c('input',{staticClass:"form-control label",attrs:{"type":"text","name":"soort","readonly":""},domProps:{"value":`${_vm.value}`}})])
}
var staticRenderFns = []

export { render, staticRenderFns }